import { render } from "./ListHeading.vue?vue&type=template&id=9853416a"
import script from "./ListHeading.vue?vue&type=script&lang=js"
export * from "./ListHeading.vue?vue&type=script&lang=js"

import "./ListHeading.vue?vue&type=style&index=0&id=9853416a&lang=css"
script.render = render

export default script